
import { tryFind as tryFind_1, choose, sort, contains, empty as empty_1, isEmpty, singleton as singleton_1, cons, ofArray, filter, map } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { simulationIsOpen, openSheetArrayInfo, syncArrayTextOfOpenSheet, isArrayOnlyComponent } from "./ModelHelpers.js";
import { DrawModelType_SheetT_Model__Model_GetCanvasState } from "../DrawBlock/Sheet.js";
import { getParamSlots, getDefaultParamDefs, markSheetParamsChanged } from "./ParameterView.js";
import { parseDiagramSignatureFor } from "../Simulator/CanvasExtractor.js";
import { CCForm, copiesOfArray, ArrayInfo as ArrayInfo_1, Project, LoadedComponent } from "../Common/CommonTypes.js";
import { Msg, Model } from "../Model/ModelType.js";
import { saveOpenFileToModel, displayFileErrorNotification, openFileInProject$0027, isFileInProject, saveOpenFileActionWithModelUpdate } from "./MenuHelpers.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { tryParse } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { FSharpRef } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { Constants_maxArrayCopies } from "../Simulator/ArrayElaborate.js";
import { fieldLabel } from "./PropertiesHelp.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { initializeInfinite, filter as filter_1, head, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { CSSProp, DOMAttr, HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { equals, comparePrimitives, compare, stringHash, defaultOf, int32ToString } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { getTextEventValue } from "../Interface/JSHelpers.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { Option as Option_1, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Size_ISize, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { concat, join } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { tryFind, ofList, toList as toList_1 } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { ParamName, slotsUsingParam, isValidParamName } from "../Common/ParameterTypes.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { dynamicClosablePopup, dialogPopupBodyOnlyText, getText2, getText, dialogPopupBodyTwoTexts, dialogPopup } from "../DrawBlock/PopupHelpers.js";
import { maybeWarning } from "./MiscMenuView.js";
import { createEmptySheetFile, sheetFilePath, copySheetWithNewIds } from "../Interface/ComponentLibraries.js";
import { displayAlertOnError } from "./Notifications.js";
import { tryLoadComponentFromPath } from "../Interface/FilesIO.js";
import { helpText } from "./UIPopups.js";
import { Confirm_usingArraySheets, Confirm_arrayComponentIsAdvanced } from "../Common/AppMessages.js";
import { warn } from "../Shared/Log.js";

const defaultLoopName = "i";

function arrayComponentsOn(model) {
    return map((comp_1) => comp_1.Label, filter((comp) => isArrayOnlyComponent(comp.Type), DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet)[0]));
}

function setArrayInfo(model, info, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const canvas = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
        dispatch(new Msg(/* UpdateModel */ 41, [(m) => syncArrayTextOfOpenSheet(markSheetParamsChanged(new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, map((lc) => {
            const matchValue_1 = lc.Name === project.OpenFileName;
            if (matchValue_1) {
                const patternInput = parseDiagramSignatureFor(info, lc.LCParameterSlots, canvas[0], canvas[1]);
                return new LoadedComponent(lc.Name, lc.TimeStamp, lc.FilePath, lc.WaveInfo, lc.CanvasState, patternInput[0], patternInput[1], lc.LCParameterSlots, lc.Form, lc.LoadedComponentIsOutOfDate, lc.Description, lc.IsTopSheet, info);
            }
            else {
                return lc;
            }
        }, project.LoadedComponents)), m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState)))]));
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model$0027, dispatch$0027) => {
            saveOpenFileActionWithModelUpdate(model$0027, dispatch$0027);
        }, dispatch]));
    }
}

/**
 * What the Properties pane shows for the open sheet when it is an array component: nothing at all
 * when it is not, so an ordinary sheet's properties are unchanged by the feature existing.
 * 
 * The copy count is here rather than in a dialog because it is the sheet's most important
 * property - it is what the sheet MEANS - and the pane is where a sheet's properties are.
 */
export function viewArraySettings(model, dispatch) {
    let option_1, n, children, s_2;
    const matchValue = openSheetArrayInfo(model);
    if (matchValue != null) {
        const info = matchValue;
        const loopName = info.LoopParam.fields[0];
        const simIsOpen = simulationIsOpen(model);
        const openName = defaultArg((option_1 = model.CurrentProj, (option_1 != null) ? option_1.OpenFileName : undefined), "");
        let typedHere;
        const matchValue_1 = model.ArrayCopiesTyped;
        let matchResult, sheet_1, text_1;
        if (matchValue_1 != null) {
            if ((matchValue_1[1], matchValue_1[0] === openName)) {
                matchResult = 0;
                sheet_1 = matchValue_1[0];
                text_1 = matchValue_1[1];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                typedHere = text_1;
                break;
            }
            default:
                typedHere = undefined;
        }
        const setTyped = (text_2) => {
            dispatch(new Msg(/* UpdateModel */ 41, [(m) => {
                let option_4;
                return new Model(m.WindowWidth, m.KeyFocusPane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, (option_4 = text_2, (option_4 != null) ? [openName, option_4] : undefined), m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, m.CurrentProj, m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState);
            }]));
        };
        let typedProblem;
        const option_6 = typedHere;
        if (option_6 != null) {
            const text_3 = option_6;
            let matchValue_2;
            let outArg = 0;
            matchValue_2 = [tryParse(text_3.trim(), 511, false, 32, new FSharpRef(() => (outArg | 0), (v) => {
                outArg = (v | 0);
            })), outArg];
            let matchResult_1;
            if (matchValue_2[0]) {
                if ((n = (matchValue_2[1] | 0), (n >= 1) && (n <= Constants_maxArrayCopies))) {
                    matchResult_1 = 0;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    typedProblem = undefined;
                    break;
                }
                default:
                    typedProblem = (`Number of copies must be a number >= 1 and <= ${Constants_maxArrayCopies}`);
            }
        }
        else {
            typedProblem = undefined;
        }
        const commit = () => {
            let n_2;
            if (typedHere != null) {
                const text_4 = typedHere;
                let matchValue_3;
                let outArg_1 = 0;
                matchValue_3 = [tryParse(text_4.trim(), 511, false, 32, new FSharpRef(() => (outArg_1 | 0), (v_1) => {
                    outArg_1 = (v_1 | 0);
                })), outArg_1];
                let matchResult_2;
                if (matchValue_3[0]) {
                    if ((n_2 = (matchValue_3[1] | 0), ((n_2 >= 1) && (n_2 <= Constants_maxArrayCopies)) && (n_2 !== info.Copies))) {
                        matchResult_2 = 0;
                    }
                    else {
                        matchResult_2 = 1;
                    }
                }
                else {
                    matchResult_2 = 1;
                }
                switch (matchResult_2) {
                    case 0: {
                        setArrayInfo(model, new ArrayInfo_1(info.LoopParam, matchValue_3[1]), dispatch);
                        break;
                    }
                }
                setTyped(undefined);
            }
        };
        let copyBox;
        const children_2 = [fieldLabel("Copies"), input(cons(new Option(/* Type */ 1, [IInputType.Number$]), toList(delay(() => append(singleton(new Option(/* Props */ 15, [ofArray([["style", {
            width: "120px",
        }], new HTMLAttr(/* Min */ 119, [1]), new HTMLAttr(/* Max */ 114, [Constants_maxArrayCopies]), new DOMAttr(/* OnBlur */ 8, [(_arg) => {
            commit();
        }]), new DOMAttr(/* OnKeyDown */ 15, [(ev) => {
            if (ev.key === "Enter") {
                ev.stopPropagation();
                commit();
            }
        }])])])), delay(() => append((typedProblem != null) ? singleton(new Option(/* CustomClass */ 16, ["is-danger"])) : empty(), delay(() => append(singleton(new Option(/* Disabled */ 4, [simIsOpen])), delay(() => append(singleton(new Option(/* Value */ 8, [defaultArg(typedHere, int32ToString(info.Copies))])), delay(() => singleton(new Option(/* OnChange */ 13, [(ev_1) => {
            setTyped(getTextEventValue(ev_1));
        }])))))))))))))), (children = [defaultArg(typedProblem, "")], react.createElement("div", {
            className: "propertyMessage",
        }, ...children))];
        copyBox = react.createElement("div", {}, ...children_2);
        let loopBox;
        const props_4 = [["style", {
            marginTop: "6px",
        }]];
        const children_4 = [fieldLabel("Loop variable"), input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Props */ 15, [singleton_1(["style", {
            width: "120px",
        }])]), new Option(/* Disabled */ 4, [true]), new Option(/* Value */ 8, [loopName])]))];
        loopBox = react.createElement("div", keyValueList(props_4, 1), ...children_4);
        let explanation;
        const props_8 = [["style", {
            fontSize: "0.85em",
            color: "grey",
            marginTop: "6px",
        }]];
        const children_6 = [`This sheet's hardware is ${info.Copies} copies of what is drawn on it. Write '${loopName}' in any property box to make one copy differ from the next: it counts 0 to ${info.Copies - 1}.`, react.createElement("br", {}), (s_2 = "Changing the number of copies changes how many ports this component has, so every instance of it elsewhere will need updating.", s_2)];
        explanation = react.createElement("p", keyValueList(props_8, 1), ...children_6);
        let stopButton;
        const matchValue_4 = arrayComponentsOn(model);
        if (isEmpty(matchValue_4)) {
            stopButton = button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsDanger]), new Option_1(/* Size */ 1, [Size_ISize.IsSmall]), new Option_1(/* Disabled */ 16, [simIsOpen]), new Option_1(/* Props */ 17, [singleton_1(["style", {
                marginTop: "8px",
            }])]), new Option_1(/* OnClick */ 18, [(_arg_1) => {
                setArrayInfo(model, undefined, dispatch);
            }])]), singleton_1("Make this an ordinary sheet"));
        }
        else {
            const props_10 = [["style", {
                fontSize: "0.85em",
                color: "grey",
                marginTop: "8px",
            }]];
            const children_8 = [("This cannot become an ordinary sheet while it holds " + join(", ", matchValue_4)) + ": those components only mean something on an array component."];
            stopButton = react.createElement("p", keyValueList(props_10, 1), ...children_8);
        }
        const props_12 = [["style", {
            marginBottom: "10px",
        }]];
        const children_10 = [fieldLabel("Array component"), copyBox, loopBox, explanation, stopButton];
        return react.createElement("div", keyValueList(props_12, 1), ...children_10);
    }
    else {
        return defaultOf();
    }
}

const defaultCopies = 4;

function loopNameOf(defaultName, typed) {
    if (typed.trim() === "") {
        return defaultName;
    }
    else {
        return typed.trim();
    }
}

function declaredNames(sheet) {
    let option_1;
    return defaultArg((option_1 = sheet, (option_1 != null) ? map((arg_1) => arg_1[0].fields[0], toList_1(getDefaultParamDefs(option_1))) : undefined), empty_1());
}

function freeLoopName(sheet) {
    const taken = declaredNames(sheet);
    return head(filter_1((name) => {
        if (isValidParamName(name)) {
            return !contains(name, taken, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            });
        }
        else {
            return false;
        }
    }, append([defaultLoopName, "j", "k"], initializeInfinite((n) => (`${defaultLoopName}${n + 1}`)))));
}

function componentsUsingName(sheet, name) {
    const labelOf = ofList(map((c) => [c.Id, c.Label], sheet.CanvasState[0]), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    return sort(List_distinct(choose((tupledArg) => tryFind(tupledArg[0].CompId, labelOf), slotsUsingParam(name, getParamSlots(sheet))), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    }), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    });
}

function loopNameProblem(sheet, defaultName, typed) {
    let option_1, tupledArg, old_1;
    const name = loopNameOf(defaultName, typed);
    const sheetName = defaultArg((option_1 = sheet, (option_1 != null) ? concat("\'", option_1.Name, "\'") : undefined), "this sheet");
    let renamedAwayFrom;
    let matchValue;
    const option_6 = sheet;
    if (option_6 != null) {
        const s_1 = option_6;
        const option_4 = s_1.ArrayInfo;
        matchValue = ((option_4 != null) ? [s_1, option_4] : undefined);
    }
    else {
        matchValue = undefined;
    }
    let matchResult, info_2, s_3;
    if (matchValue != null) {
        if ((matchValue[0], !equals(matchValue[1].LoopParam, new ParamName(name)))) {
            matchResult = 0;
            info_2 = matchValue[1];
            s_3 = matchValue[0];
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_1 = componentsUsingName(s_3, info_2.LoopParam);
            renamedAwayFrom = (isEmpty(matchValue_1) ? undefined : [info_2.LoopParam.fields[0], matchValue_1]);
            break;
        }
        default:
            renamedAwayFrom = undefined;
    }
    if (!isValidParamName(name)) {
        return concat("\'", name, "\' cannot be a loop variable: a name is a letter followed by letters and digits, and not min, max or clog2");
    }
    else if (contains(name, declaredNames(sheet), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })) {
        return concat(sheetName, " already has a property called \'", name, "\', and one word cannot mean both - the loop variable counts the copies, while a property is set once per instance. Choose another name.");
    }
    else {
        const option_8 = renamedAwayFrom;
        if (option_8 != null) {
            return (tupledArg = option_8, (old_1 = tupledArg[0], `${sheetName} uses '${old_1}' in the properties of ${join(", ", tupledArg[1])}, and renaming the loop variable here does not rewrite them. Copy it as '${old_1}', or change those components on ${sheetName} first.`));
        }
        else {
            return undefined;
        }
    }
}

function askForName(title, prompt, sheet, defaultLoop, project, make, model, dispatch) {
    let placeholder_1;
    dialogPopup(title, (placeholder_1 = concat("default: ", defaultLoop), (model_1) => dialogPopupBodyTwoTexts((dialogData) => {
        const children_2 = [prompt, react.createElement("br", {}), defaultArg(maybeWarning(getText(dialogData), project), react.createElement("div", {}))];
        return react.createElement("div", {}, ...children_2);
    }, "Insert array component name", (dialogData_1) => {
        const children_6 = toList(delay(() => append(singleton(react.createElement("br", {})), delay(() => {
            let s_1;
            return append(singleton((s_1 = "What should its loop variable be called? Write this in any property box on the sheet to make one copy differ from the next.", s_1)), delay(() => append(singleton(react.createElement("br", {})), delay(() => {
                let props_10;
                const matchValue = loopNameProblem(sheet, defaultLoop, getText2(dialogData_1));
                if (matchValue == null) {
                    return singleton(defaultOf());
                }
                else {
                    const msg = matchValue;
                    return singleton((props_10 = [["style", {
                        color: "red",
                    }]], react.createElement("span", keyValueList(props_10, 1), msg)));
                }
            }))));
        }))));
        return react.createElement("div", {}, ...children_6);
    }, placeholder_1, dispatch, model_1)), "Create", (model$0027) => {
        make(getText(model$0027.PopupDialogData).toLocaleLowerCase(), loopNameOf(defaultLoop, getText2(model$0027.PopupDialogData)), model$0027);
        dispatch(Msg.ClosePopup);
        dispatch(Msg.FinishUICmd);
    }, (model$0027_1) => {
        const text = getText(model$0027_1.PopupDialogData);
        if (((text === "") ? true : isFileInProject(text, project)) ? true : (maybeWarning(text, project) != null)) {
            return true;
        }
        else {
            return loopNameProblem(sheet, defaultLoop, getText2(model$0027_1.PopupDialogData)) != null;
        }
    }, empty_1(), dispatch);
}

function askForLoopVariable(title, sheet, make, dispatch) {
    let placeholder;
    const defaultLoop = freeLoopName(sheet);
    dialogPopup(title, (placeholder = concat("default: ", defaultLoop), (model) => dialogPopupBodyOnlyText((dialogData) => {
        const children_2 = toList(delay(() => append(singleton(concat("\'", sheet.Name, "\' will become an array component. What should its loop variable be called? Write this in any property box on the sheet to make one copy differ from the next.")), delay(() => append(singleton(react.createElement("br", {})), delay(() => {
            let props_2;
            const matchValue = loopNameProblem(sheet, defaultLoop, getText(dialogData));
            if (matchValue == null) {
                return singleton(defaultOf());
            }
            else {
                const msg = matchValue;
                return singleton((props_2 = [["style", {
                    color: "red",
                }]], react.createElement("span", keyValueList(props_2, 1), msg)));
            }
        }))))));
        return react.createElement("div", {}, ...children_2);
    }, placeholder, dispatch, model)), "Make it an array component", (model$0027) => {
        make(loopNameOf(defaultLoop, getText(model$0027.PopupDialogData)), model$0027);
        dispatch(Msg.ClosePopup);
        dispatch(Msg.FinishUICmd);
    }, (model$0027_1) => (loopNameProblem(sheet, defaultLoop, getText(model$0027_1.PopupDialogData)) != null), empty_1(), dispatch);
}

function addArraySheet(project, name, loopName, canvasFrom, model, dispatch) {
    let option_3, option_1;
    if (canvasFrom != null) {
        copySheetWithNewIds(canvasFrom.FilePath, sheetFilePath(project, name));
    }
    else {
        displayAlertOnError(dispatch, createEmptySheetFile(project, name));
    }
    const copiesOf = defaultArg((option_3 = ((option_1 = canvasFrom, (option_1 != null) ? option_1.ArrayInfo : undefined)), (option_3 != null) ? copiesOfArray(option_3) : undefined), defaultCopies) | 0;
    const info_1 = (loop) => (new ArrayInfo_1(new ParamName(loop), copiesOf));
    const matchValue = tryLoadComponentFromPath(sheetFilePath(project, name));
    if (matchValue.tag === 0) {
        const loaded = matchValue.fields[0];
        let patternInput;
        const tupledArg = loaded.CanvasState;
        patternInput = parseDiagramSignatureFor(info_1(loopName), loaded.LCParameterSlots, tupledArg[0], tupledArg[1]);
        openFileInProject$0027(true, name, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, cons(new LoadedComponent(name, loaded.TimeStamp, loaded.FilePath, loaded.WaveInfo, loaded.CanvasState, patternInput[0], patternInput[1], loaded.LCParameterSlots, loaded.Form, true, loaded.Description, loaded.IsTopSheet, info_1(loopName)), filter((l) => (l.Name !== name), project.LoadedComponents))), model, dispatch);
    }
    else {
        displayFileErrorNotification(matchValue.fields[0], dispatch);
    }
}

/**
 * The Catalogue's "New array component": what an array component IS, and the three ways to get
 * one. An existing sheet can become one, because the usual way to find out you want an array is to
 * have drawn one copy of it already.
 */
export function newArrayComponentPopup(model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const openSheet = tryFind_1((lc) => {
            if (lc.Name === project.OpenFileName) {
                return equals(lc.Form, CCForm.User);
            }
            else {
                return false;
            }
        }, project.LoadedComponents);
        const choice = (label, description, action) => {
            let props;
            const props_2 = [["style", {
                marginBottom: "10px",
            }]];
            const children_2 = [button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsInfo]), new Option_1(/* OnClick */ 18, [(_arg) => {
                dispatch(Msg.ClosePopup);
                action();
            }])]), singleton_1(label)), (props = [["style", {
                fontSize: "0.85em",
                color: "grey",
                marginTop: "4px",
            }]], react.createElement("p", keyValueList(props, 1), description))];
            return react.createElement("div", keyValueList(props_2, 1), ...children_2);
        };
        dynamicClosablePopup("New array component", (_arg_1) => {
            let info, lc_2, lc_1;
            const children_4 = [helpText(Confirm_arrayComponentIsAdvanced), react.createElement("hr", {}), helpText(Confirm_usingArraySheets), react.createElement("hr", {}), choice("New array component", "An empty sheet to draw one copy on.", () => {
                askForName("New array component", "A new sheet will be created for it:", undefined, freeLoopName(undefined), project, (name, loop, model$0027) => {
                    addArraySheet(project, name, loop, undefined, model$0027, dispatch);
                }, model, dispatch);
            }), (openSheet == null) ? defaultOf() : ((openSheet.ArrayInfo != null) ? ((info = openSheet.ArrayInfo, (lc_2 = openSheet, choice("Copy the current array component design sheet as a new array component", "A copy of the current sheet is made with properties and content you can modify", () => {
                if (model.SavedSheetIsOutOfDate) {
                    const matchValue_1 = saveOpenFileToModel(model);
                    let matchResult, p;
                    if (matchValue_1 != null) {
                        if (matchValue_1.CurrentProj != null) {
                            matchResult = 0;
                            p = matchValue_1.CurrentProj;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0: {
                            dispatch(new Msg(/* SetProject */ 39, [p]));
                            break;
                        }
                    }
                }
                askForName("Copy as an array component", `A separate array component will be made from '${lc_2.Name}', which has ${copiesOfArray(info)} copies. The copy starts the same and can then be changed on its own. It will be called:`, lc_2, info.LoopParam.fields[0], project, (name_1, loop_3, model$0027_2) => {
                    addArraySheet(project, name_1, loop_3, lc_2, model$0027_2, dispatch);
                }, model, dispatch);
            })))) : ((lc_1 = openSheet, choice("Turn the current design sheet into an array component", "The current sheet is used as one copy of the array: you can add array components to it.", () => {
                askForLoopVariable("Make an array component", lc_1, (loop_1, _arg_2) => {
                    dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model$0027_1, dispatch$0027) => {
                        setArrayInfo(model$0027_1, new ArrayInfo_1(new ParamName(loop_1), defaultCopies), dispatch$0027);
                    }, dispatch]));
                }, dispatch);
            }))))];
            return react.createElement("div", {}, ...children_4);
        }, (_arg_3) => {
            const props_10 = [["style", {
                display: "flex",
                justifyContent: "flex-end",
            }]];
            const children_6 = [button(singleton_1(new Option_1(/* OnClick */ 18, [(_arg_4) => {
                dispatch(Msg.ClosePopup);
            }])), singleton_1("Cancel"))];
            return react.createElement("div", keyValueList(props_10, 1), ...children_6);
        }, ofArray([new CSSProp(/* Width */ 395, [1200]), new CSSProp(/* MaxWidth */ 249, ["90vw"])]), dispatch);
    }
    else {
        warn("newArrayComponentPopup called with no project open");
    }
}

